function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFinalSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 166.345,
    height: 120,
    viewBox: "0 0 166.345 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ovtzow08la"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 12089",
    transform: "translate(0 -.315)",
    style: {
      stroke: "#707070",
      fill: "#fff"
    },
    d: "M0 0h166.345v120H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15444",
    transform: "translate(0 .314)",
    style: {
      clipPath: "url(#ovtzow08la)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 15443"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 54775",
    d: "M51.865 5.336a6.78 6.78 0 0 0 6.9 0L63.785 2a4.05 4.05 0 0 1 5.67 1.208L72.681 8.3a6.769 6.769 0 0 0 6.305 2.807l5.939-1.007a4.048 4.048 0 0 1 4.69 3.407l.881 5.949a6.781 6.781 0 0 0 4.619 5.136l5.827 1.5a4.06 4.06 0 0 1 2.9 5.029l-1.614 5.783a6.777 6.777 0 0 0 2.132 6.568l4.73 3.752a4.055 4.055 0 0 1 .6 5.769l-3.84 4.636a6.773 6.773 0 0 0-.722 6.866l2.789 5.332a4.054 4.054 0 0 1-1.791 5.517l-5.395 2.678a6.775 6.775 0 0 0-3.451 5.98l.373 6.005a4.057 4.057 0 0 1-3.883 4.313l-6.014.255a6.781 6.781 0 0 0-5.586 4.062l-2.092 5.636a4.056 4.056 0 0 1-5.3 2.363l-5.6-2.215a6.77 6.77 0 0 0-6.753 1.435l-4.208 4.3a4.059 4.059 0 0 1-5.8 0l-4.214-4.3a6.778 6.778 0 0 0-6.755-1.434l-5.6 2.215a4.052 4.052 0 0 1-5.3-2.362l-2.1-5.636a6.779 6.779 0 0 0-5.586-4.062l-6.011-.255a4.059 4.059 0 0 1-3.883-4.313l.376-6.005A6.78 6.78 0 0 0 9.9 78.026l-5.4-2.677a4.054 4.054 0 0 1-1.792-5.517L5.5 64.5a6.764 6.764 0 0 0-.724-6.864L.935 52.995a4.052 4.052 0 0 1 .6-5.766l4.735-3.753a6.778 6.778 0 0 0 2.13-6.568l-1.616-5.786a4.055 4.055 0 0 1 2.9-5.024l5.832-1.506a6.78 6.78 0 0 0 4.619-5.135l.88-5.949A4.051 4.051 0 0 1 25.7 10.1l5.939 1.006a6.764 6.764 0 0 0 6.3-2.807l3.225-5.088A4.051 4.051 0 0 1 46.843 2z",
    transform: "translate(25.117 3.265)",
    style: {
      fill: "#01a685"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 54776",
    d: "M161.937 126.441a35.791 35.791 0 1 1-35.792-35.786 35.792 35.792 0 0 1 35.792 35.786z",
    transform: "translate(-45.715 -66.765)",
    style: {
      fill: "#01a685"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 54777",
    d: "m176.405 221.036-14.326-14.326 4.773-4.775 9.553 9.551 21.488-21.491 4.773 4.777z",
    transform: "translate(-101.942 -144.641)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinalSubmit);
export default __webpack_public_path__ + "static/media/finalSubmit.8c6937d2d231cc9c314e1331d351507c.svg";
export { ForwardRef as ReactComponent };